import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faGraduationCap,
	faCalendarAlt,
	faPlus,
	faChevronDown,
	faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "../../../../hooks";
import { ASSESSMENT_TYPES } from "../../hooks/useAssessmentForm";
import styles from "./AssessmentsSidebar.module.css";

const AssessmentsSidebar = ({
	selectedSemester,
	setSelectedSemester,
	departmentSubjects,
	selectedSubject,
	setSelectedSubject,
	formVisible,
	setFormVisible,
	title,
	setTitle,
	type,
	setType,
	points,
	setPoints,
	formMonth,
	setFormMonth,
	monthsToDisplay,
	handleAddAssessment,
	isCreating,
	isMobile,
}) => {
	const { t } = useTranslation();

	return (
		<aside className={styles.sidebar}>
			{/* FIXED: Semester switch with original tab design */}
			<div className={styles.semesterSwitch}>
				<label className={styles.semesterSwitchLabel}>
					{t("assessment.semester") || "Semester"}
				</label>
				<div className={styles.semesterTabs}>
					<div
						className={`${styles.semesterTab} ${
							selectedSemester === "First Semester" ? styles.active : ""
						}`}
						onClick={() => setSelectedSemester("First Semester")}
					>
						{t("assessment.firstSemester") || "First Semester"}
					</div>
					<div
						className={`${styles.semesterTab} ${
							selectedSemester === "Second Semester" ? styles.active : ""
						}`}
						onClick={() => setSelectedSemester("Second Semester")}
					>
						{t("assessment.secondSemester") || "Second Semester"}
					</div>
				</div>
			</div>

			{/* FIXED: Subject selector with original styling */}
			<div className={styles.subjectSelector}>
				<label className={styles.selectorLabel}>
					{t("assessment.subject") || "Subject"}
				</label>
				<select
					className={styles.selectorControl}
					value={selectedSubject || ""}
					onChange={(e) => setSelectedSubject(e.target.value)}
					disabled={departmentSubjects.length === 0}
				>
					<option value="" disabled>
						{t("assessment.selectSubject") || "Select a subject"}
					</option>
					{departmentSubjects.map((subject) => (
						<option key={subject.id} value={subject.id}>
							{subject.name}
						</option>
					))}
				</select>
			</div>

			{/* FIXED: Add Assessment form with original layout */}
			<div className={styles.sidebarSection}>
				<h2 className={styles.sectionTitle}>
					<FontAwesomeIcon
						icon={faPlus}
						className={styles.sectionTitleIcon}
					/>
					{t("assessment.addNewAssessment") || "Add New Assessment"}
				</h2>

				<div className={styles.formGroup}>
					<label className={styles.formLabel} htmlFor="title">
						{t("assessment.assessmentTitle") || "Assessment Title"}
					</label>
					<input
						id="title"
						type="text"
						className={styles.formControl}
						placeholder={
							t("assessment.enterTitle") || "Enter assessment title"
						}
						value={title}
						onChange={(e) => setTitle(e.target.value)}
					/>
				</div>

				<div className={styles.formGroup}>
					<label className={styles.formLabel} htmlFor="type">
						{t("assessment.assessmentType") || "Assessment Type"}
					</label>
					<select
						id="type"
						className={styles.formControl}
						value={type}
						onChange={(e) => setType(e.target.value)}
					>
						{ASSESSMENT_TYPES.map((t) => (
							<option key={t} value={t}>
								{t}
							</option>
						))}
					</select>
				</div>

				<div className={styles.formRow}>
					<div className={styles.formGroup}>
						<label className={styles.formLabel} htmlFor="points">
							{t("assessment.points") || "Points"}
						</label>
						<input
							id="points"
							type="number"
							className={styles.formControl}
							placeholder={t("assessment.points") || "Points"}
							min="0"
							max="100"
							value={points}
							onChange={(e) => setPoints(e.target.value)}
						/>
					</div>

					<div className={styles.formGroup}>
						<label className={styles.formLabel} htmlFor="month">
							{t("assessment.month") || "Month"}
						</label>
						<select
							id="month"
							className={styles.formControl}
							value={formMonth}
							onChange={(e) => setFormMonth(e.target.value)}
						>
							{monthsToDisplay.map((month) => (
								<option key={month} value={month}>
									{month}
								</option>
							))}
						</select>
					</div>
				</div>

				<button
					className={`${styles.btn} ${styles.btnPrimary} ${styles.btnBlock}`}
					onClick={handleAddAssessment}
					disabled={!selectedSubject || isCreating}
				>
					<FontAwesomeIcon icon={faPlus} />
					{isCreating
						? "Adding..."
						: t("assessment.addAssessment") || "Add Assessment"}
				</button>
			</div>
		</aside>
	);
};

export default AssessmentsSidebar;